import { ExcalidrawConfig } from "../../index.js";
import { MermaidToExcalidrawResult } from "../../interfaces.js";
import { Mindmap, MindmapNode } from "../../parser/mindmapParser.js";
import {
  transformToExcalidrawContainerSkeleton,
  transformToExcalidrawArrowSkeleton,
} from "../transformToExcalidrawSkeleton.js";

const PALETTE = [
  "#FF8800", // Sagamuda Orange
  "#00A878", // Sagamuda Green
  "#9b59b6", // Purple
  "#d63384", // Pink/Magenta
  "#e74c3c", // Red
  "#3498db", // Blue
  "#f1c40f", // Yellow
  "#1abc9c", // Teal
];

import { GraphConverter } from "../GraphConverter.js";

export const mindmapToExcalidrawSkeletonConverter = new GraphConverter({
  converter: (mindmap: Mindmap, config) => {
    const elements: any[] = [];

    mindmap.nodes.forEach((node: MindmapNode) => {
      // Use extracted styles from SVG for "intelligent" coloring
      const bgColor = node.containerStyle.fill || "#ffffff";
      const strokeColor = node.containerStyle.stroke || "#333333";
      
      // Determine text color based on background brightness
      let textColor = "#000000";
      if (bgColor && bgColor !== "transparent" && bgColor !== "none") {
        // Simple heuristic for dark backgrounds
        const isDark = bgColor.match(/#[0-9a-f]{6}/i) && 
                      parseInt(bgColor.slice(1), 16) < 0x888888;
        // Specifically check for Mermaid's blue root
        if (isDark || bgColor.toLowerCase() === "blue" || node.depth === 0) {
          textColor = "#ffffff";
        }
      }

      const skeleton = transformToExcalidrawContainerSkeleton({
        id: node.id,
        type: (node.type as any) || "rectangle",
        x: node.x,
        y: node.y,
        width: node.width,
        height: node.height,
        label: {
          text: node.text,
          fontSize: config.fontSize,
          color: textColor,
          textAlign: "center",
          verticalAlign: "middle",
        },
        bgColor,
        strokeColor,
        strokeStyle: "solid",
        strokeWidth: 1.5,
        fillStyle: "solid",
        roughness: 1,
        roundness: { type: 1 },
        groupIds: [],
      } as any);

      elements.push(skeleton);
    });

    mindmap.edges.forEach((edge) => {
      const fromNode = mindmap.nodes.find(n => n.id === edge.fromId);
      const toNode = mindmap.nodes.find(n => n.id === edge.toId);

      if (fromNode && toNode) {
        elements.push(transformToExcalidrawArrowSkeleton({
          type: "arrow",
          id: `edge-${edge.fromId}-${edge.toId}`,
          startX: fromNode.x + fromNode.width / 2,
          startY: fromNode.y + fromNode.height / 2,
          endX: toNode.x + toNode.width / 2,
          endY: toNode.y + toNode.height / 2,
          strokeColor: "#999999",
          strokeWidth: 2,
          strokeStyle: "solid",
          roughness: 1,
          startArrowhead: null,
          endArrowhead: null,
          start: { id: fromNode.id, type: (fromNode.type as any) || "rectangle" },
          end: { id: toNode.id, type: (toNode.type as any) || "rectangle" },
          groupIds: [],
        } as any));
      }
    });

    return {
      elements,
    };
  },
});
